"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 12 5';

var ChevronLeft = function ChevronLeft() {
  return _react["default"].createElement("polygon", {
    transform: "rotate(180) translate(-9, -8.75)",
    points: "0 10.2805714 4.0495 6.07257143 0 1.864 1.24716667 0.571428571 6.55141667 6.07257143 1.24716667 11.5737143"
  });
};

var _default = (0, _createSvgIcon["default"])(ChevronLeft, {
  viewBox: viewBox
});

exports["default"] = _default;